import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83b205d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge badge-pill bg-danger"
}

import { Permission } from '../../../utils/Permission';
import { DialogHandler } from '../../dialog/DialogHandler';
import { onMounted, ref } from 'vue';
import { NotifyMessageService } from '../../../biz/remote/NotifyMessageService';
import { LocalMemory } from '../../../utils/LocalMemory';
import { dayjs } from '../../../../framework/util/momentExtends';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotifyButton',
  setup(__props) {

const hasNew = ref(false)
const showDialog = () => {
  hasNew.value =false
  DialogHandler.showNotificationDialog();
};

onMounted(async ()=>{
  const biz = new NotifyMessageService();
  const result = await biz.getNewestDate();
  const newestNotifyDt = result.data;
  console.log("newestNotifyDt",newestNotifyDt)
  if (!newestNotifyDt){
    // 最新ニュース日時が取れなかったらニュースなし
    hasNew.value = false
  }else{
    const lastNotificationViewDt = LocalMemory.instance.getLocal("last_notification_dt")
    console.log("lastNotificationViewDt",lastNotificationViewDt)
    if(!lastNotificationViewDt){ 
      // 通知の最終確認日が取れなかったらニュース表示
      hasNew.value = true;    
    }
    else {
      // 通知の最終確認日が最新ニュース日時より前だったらニュースあり
      hasNew.value =  dayjs(lastNotificationViewDt).isBefore(newestNotifyDt)
    }
  }
  // if(hasNew.value){
  //   DialogHandler.showNotificationDialog()
  //   hasNew.value =false
  // }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-default w",
    onClick: showDialog
  }, [
    _createElementVNode("i", {
      style: {"font-size":"2rem"},
      class: _normalizeClass(["far fa-envelope mx-1", { 'animate__animated':hasNew.value, 'animate__bounce animate__slow':hasNew.value, 'animate__repeat-3':hasNew.value }])
    }, null, 2),
    (hasNew.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "new"))
      : _createCommentVNode("", true)
  ]))
}
}

})